import { render, staticRenderFns } from "./draw-sign.vue?vue&type=template&id=5ef7b060&scoped=true&"
import script from "./draw-sign.vue?vue&type=script&lang=js&"
export * from "./draw-sign.vue?vue&type=script&lang=js&"
import style0 from "./draw-sign.vue?vue&type=style&index=0&id=5ef7b060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef7b060",
  null
  
)

export default component.exports